/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TemplateAttributeType } from './';
import {
    TemplateAttributeTypeFromJSON,
    TemplateAttributeTypeFromJSONTyped,
    TemplateAttributeTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface TemplateAttributeForm
 */
export interface TemplateAttributeForm {
    /**
     * 
     * @type {TemplateAttributeType}
     * @memberof TemplateAttributeForm
     */
    type: TemplateAttributeType;
    /**
     * 
     * @type {string}
     * @memberof TemplateAttributeForm
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateAttributeForm
     */
    label?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TemplateAttributeForm
     */
    required: boolean;
}

/**
 * Check if a given object implements the TemplateAttributeForm interface.
 */
export function instanceOfTemplateAttributeForm(value: object): value is TemplateAttributeForm {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function TemplateAttributeFormFromJSON(json: any): TemplateAttributeForm {
    return TemplateAttributeFormFromJSONTyped(json, false);
}

export function TemplateAttributeFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateAttributeForm {
    if (json == null) {
        return json;
    }
    return {
        
        'type': TemplateAttributeTypeFromJSON(json['type']),
        'name': json['name'],
        'label': json['label'] == null ? undefined : json['label'],
        'required': json['required'],
    };
}

export function TemplateAttributeFormToJSON(value?: TemplateAttributeForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': TemplateAttributeTypeToJSON(value['type']),
        'name': value['name'],
        'label': value['label'],
        'required': value['required'],
    };
}

